module.exports = __webpack_public_path__ + "img/GoSuCanEnergy@2x.4f567d73.png";